import { Partition } from "@/app/domain";
import {
    createMountsGlazingGasketConfig,
    createMountsFunctionalMullionsConfig,
    createMountsToptrackSlidingDoorConfig,
    createMountsMullionsHorizontalConfig,
    createMountsMullionsVerticalConfig,
    createMountsCGFChannelHorizontalConfig,
    createMountsCGFChannelVerticalConfig,
    createMountsCGFFrameVerticalConfig,
} from "../../base";

import { IComponentConfig } from "@/app/@types/base-component";
import { MountsService } from "@/app/services/mounts.service";
import { LineDividerCalculationService } from "@/app/services/line-dividers.service";
import { CGF350Code } from "@/app/constants";

const createSlidingDoorMountsToptrackSlidingDoorConfig = (
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    partition: Partition,
): IComponentConfig => {
    const toptrackStuctureCode = MountsService.getTopTrack(partition);

    return createMountsToptrackSlidingDoorConfig()
        .structureType(toptrackStuctureCode)
        .qty(0)
        .area(1)
        .build();
};

const createSlidingDoorMountsCGFFrameVerticalConfig = (
    partition: Partition,
): IComponentConfig => {
    const length = MountsService.getCGFFrameVertical(partition);

    return createMountsCGFFrameVerticalConfig().qty(0).area(length).build();
};

const createSlidingDoorMountsCGFChannelVerticalConfig = (
    partition: Partition,
): IComponentConfig => {
    const length = MountsService.getCGFChannelVertical(partition);

    return createMountsCGFChannelVerticalConfig().qty(0).area(length).build();
};

const createSlidingDoorMountsCGFChannelHorizontalConfig = (
    partition: Partition,
): IComponentConfig => {
    const partitionWidth = MountsService.getTotalWidth(partition);

    return createMountsCGFChannelHorizontalConfig()
        .qty(0)
        .area(partitionWidth)
        .build();
};

const createSlidingDoorMountsFunctionalMullionsConfig = (
    partition: Partition,
): IComponentConfig => {
    const doorWidth = MountsService.getDoorTotalWidth(partition);
    const qty = MountsService.getFunctionalMullionLength(partition);

    return createMountsFunctionalMullionsConfig()
        .qty(2)
        .width(doorWidth)
        .area(qty)
        .build();
};

const createSlidingDoorMountsMullionsHorizontalConfig = (
    partition: Partition,
): IComponentConfig => {
    const width = MountsService.getTotalWidth(partition);
    const doorWidth = MountsService.getDoorTotalWidth(partition);
    const height = MountsService.getTotalHeight(partition);

    // Переделали формулу, в задаче 8698v2rfj: было вот так width * horizontalLinesQty * sides
    const sides = 4;

    const horizontalLinesQty =
        LineDividerCalculationService.calculateHorizontalDividers(
            CGF350Code,
            height,
        );

    const additionalDoorWidth = doorWidth * sides;

    const qty = Math.round(width * horizontalLinesQty + additionalDoorWidth) || 0;

    return createMountsMullionsHorizontalConfig()
        .qty(horizontalLinesQty)
        .width(width)
        .area(qty)
        .build();
};

const createSlidingDoorMountsMullionsVerticalConfig = (
    partition: Partition,
): IComponentConfig => {
    const width = MountsService.getTotalWidth(partition);
    const height = MountsService.getTotalHeight(partition);
    const sides = 1; // Было 2 стороны, но потом почему-то изменилось на 1

    const verticalLinesQty =
        LineDividerCalculationService.calculateVerticalDividers(
            CGF350Code,
            width,
        );

    const qty = Math.round(height * verticalLinesQty * sides) || 0;

    return createMountsMullionsVerticalConfig()
        .qty(verticalLinesQty)
        .width(height)
        .area(qty)
        .build();
};

const createSlidingDoorMountsGlazingGasketConfig = (
    partition: Partition,
): IComponentConfig => {
    const totalWidth = MountsService.getTotalWidth(partition);
    const totalHeight = MountsService.getTotalHeight(partition);
    const doorWidth = MountsService.getDoorTotalWidth(partition);
    const hasTransom = MountsService.hasOverdoorTransom(partition);

    const sides = 2;
    const transomMultiplier = hasTransom ? 1 : sides;

    const totalDoorWidth = doorWidth * transomMultiplier;//top and bottom sides
    const horizontalGaskets = totalWidth * sides - totalDoorWidth;//top and bottom sides
    const verticalGaskets = totalHeight * sides;//left and right sides

    const qty = Math.round((horizontalGaskets + verticalGaskets) * sides) || 0; //inner and outer sides

    return createMountsGlazingGasketConfig().qty(0).area(qty).build();
};

export const CGF350SlidingDoorsConfigs = (partition: Partition) => [
    createSlidingDoorMountsToptrackSlidingDoorConfig(partition),
    createSlidingDoorMountsCGFFrameVerticalConfig(partition),
    createSlidingDoorMountsCGFChannelHorizontalConfig(partition),
    createSlidingDoorMountsCGFChannelVerticalConfig(partition),
    createSlidingDoorMountsFunctionalMullionsConfig(partition),
    createSlidingDoorMountsMullionsHorizontalConfig(partition),
    createSlidingDoorMountsMullionsVerticalConfig(partition),
    createSlidingDoorMountsGlazingGasketConfig(partition),
];
